module.exports = __webpack_public_path__ + "direct-es2015.f2c137ecc5c91487d9f8.worker.js"